import Vue from "vue";

import {
  getLedgerBiTotal,
  getLedgerBiToday,
  getLedgerBiTotalInRub
} from "@/api";
//
export default {
  namespaced: true,

  state: {
    ledgerBiTotal: {},
    ledgerBiToday: {},
    ledgerBiTotalInRub: {},
    loadingTotal: false,
    loadingToday: true,
    loadingTotalInRub: true
  },

  mutations: {
    setLedgerBiTotal(state, ledgerBiTotal) {
      state.ledgerBiTotal = ledgerBiTotal;
    },
    setLedgerBiToday(state, ledgerBiToday) {
      state.ledgerBiToday = ledgerBiToday;
    },
    setLedgerBiTotalInRub(state, ledgerBiTotalInRub) {
      state.ledgerBiTotalInRub = ledgerBiTotalInRub;
    },
    setLoadingTotal(state, loadingTotal) {
      state.loadingTotal = loadingTotal;
    },
    setLoadingToday(state, loadingToday) {
      state.loadingToday = loadingToday;
    },
    setLoadingTotalInRub(state, loadingTotalInRub) {
      state.loadingTotalInRub = loadingTotalInRub;
    }
  },

  actions: {
    async getLedgerBiTotal(store, payload = {}) {
      store.commit("setLoadingTotal", true);
      try {
        const resp = await getLedgerBiTotal();
        if (typeof resp !== "undefined" && resp.data.status) {
          store.commit("setLedgerBiTotal", resp.data.result);
          return resp.data.result;
        }
        throw new Error("Не удалось получить данные");
      } finally {
        store.commit("setLoadingTotal", false);
      }
    },
    async getLedgerBiToday(store, payload = {}) {
      store.commit("setLoadingToday", true);
      try {
        const resp = await getLedgerBiToday();
        if (typeof resp !== "undefined" && resp.data.status) {
          store.commit("setLedgerBiToday", resp.data.result);
          return resp.data.result;
        }
        throw new Error("Не удалось получить данные");
      } finally {
        store.commit("setLoadingToday", false);
      }
    },
    async getLedgerBiTotalInRub(store, payload = {}) {
      store.commit("setLoadingTotalInRub", true);
      try {
        const resp = await getLedgerBiTotalInRub();
        if (typeof resp !== "undefined" && resp.data.status) {
          store.commit("setLedgerBiTotalInRub", resp.data.result);
          return resp.data.result;
        }
        throw new Error("Не удалось получить данные");
      } finally {
        store.commit("setLoadingTotalInRub", false);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerBi.js